module.exports = __webpack_public_path__ + "static/media/zamzam3.e392a37e.jpeg";